export default {
    // 马来西亚语
    LOCALE_HTML: {
        'msg.language': 'ms_MY',
        'msg.title': 'Tajuk',
        'msg.type': 'Kategori soalan',
        'msg.des': 'Penjelasan soalan',
        'msg.phone': 'Nombor telefon bimbit',
        'msg.regionCode': 'Kod kawasan',
        'msg.email': 'Peti mel',
        'msg.choose': 'Pilih jenis',
        'msg.detail': 'Perincian mesej',
        'msg.back': 'Balik',
        'your.msg': 'Sila tinggalkan mesej',
        'msg.record': 'Catatan mesej',
        'msg.success': 'Kejayaan yang meninggalkan mesej',
        'to.record': 'Pergi ke catatan mesej',
        completed: 'Selesai',
        submit: 'Serahkan',
        'success.desc': 'Mesej anda dah berjaya diserahkan, terima kasih ',
        'msg.form.input': 'Masukkan',
        'msg.reply': 'Membalas',
        'comment.suc': 'Terima kasih atas penilaian anda!',
        'comment.fail': 'Kegagalan penyerahan',
        'comment.placeholder': 'Cadangan untuk perkhidmatan kami dialu-alukan',
        'reply.suc': 'Kejayaan penyerahan',
        'reply.fail': 'Masukkan kandungan balasan anda',
        'reply.placeholder': 'Masukkan kandungan balasan anda',
        'msg.more': 'Lihat lagi',
        'msg.collapse': 'Runtuh',
        'msg.myservice': 'Penilaian perkhidmatan saya',
        'msg.evaluate': 'Penilaian perkhidmatan',
        'msg.evaluateTitle': 'Penilaian perkhidmatan',
        'msg.score': 'Skor',
        'msg.remark': 'Komen',
        'msg.status.created': 'Dah dicipta',
        'msg.status.pending': 'Yang belum selesai',
        'msg.status.processing': 'Dalam pemprosesan',
        'msg.status.solved': 'Dah selesai',
        'msg.service.reply': 'Balasan perkhidmat pelanggan',
        'msg.my.reply': 'Balasan awak',
        'msg.toast.des': 'Tiada penjelasan soalan ',
        'msg.toast.type': 'Tiada kategori soalan',
        'msg.toast.title': 'Tiada tajuk',
        'msg.toast.none': 'Tidak dapat dikosongkan',
        'msg.toast.noAnnex': 'Memuat naik lampiran',
        'msg.toast.noEmail': 'Peti mel tidak dapat dikosongkan',
        'msg.toast.noTel': 'Nombor telefon bimbit tidak dapat dikosongkan',
        'msg.toast.noRegionCode': 'Kod kawasan tidak boleh kosong',
        'msg.toast.noZone': 'Sila pilih zon waktu',
        'msg.toast.noDateTime': 'Sila pilih masa tarikh',
        'msg.toast.email': 'Masukkan peti mel benar',
        'msg.toast.tel': 'Masukkan nombor telefon bimbit benar',
        'msg.toast.regionCode': 'Sila pilih kod kawasan',
        'msg.toast.num': 'Masukkan angka benar',
        'msg.toast.annex': 'Memuat naik lampiran',
        'msg.toast.char': 'Masukkan watak benar',
        'msg.list.none': 'Tiada data sementara',
        'msg.form.choose': 'Sila pilih',
        'msg.form.chooseZone': 'Pilih zon waktu',
        'msg.form.chooseTime': 'Pilih Masa',
        'msg.form.chooseDate': 'Pilih Tarikh',
        'msg.form.sure': 'Pasti',
        'msg.form.search': 'Mencari…',
        'msg.form.uploadError': 'Kesalahan format',
        'msg.form.uploadXss':
            'Muat naik gagal, kandungan fail mengandungi skrip haram',
        'msg.update.time': 'dikemas kini pada',
        'msg.replace.images': 'gambar',
        MSG015: ({ name }) => `${name} Adakah menyelesaikan masalah anda? `,
        MSG016: 'selesai',
        MSG017: 'tidak diselesaikan',
        MSG019: 'serahkan',
        MSG072: 'Label penilaian tidak boleh kosong! ',
        MSG073: 'Bahasa penilaian tidak boleh kosong! ',
        MSG074: 'Label:',
        MSG075: 'Adakah ia diselesaikan:',
        MSG076: 'Sila pilih sama ada masalah itu telah diselesaikan',
        MSG015: 'Adakah tiket ini menyelesaikan masalah anda?',

        'file.size.limit': 'Saiz fail tidak dapat melebihi daripada 50MB',
        'detail.file.limit':
            '15 buah sebanyak-banyaknya, saiznya tidak dapat melebihi daripada 50M',
        'form.question.des.tip': 'Masukkan penjelasan soalan',
        'form.title.tip': 'Masukkan tajuk',
        'form.class.tip': 'Pilih jenis soalan',
        'upload.file': 'Memuat naik lampiran',
        'file.count.limit':
            'Cuma dapat memuat naik 15 buah lampiran sebanyaknya',
        'select.search.placeholder': 'Mencari kata kunci',
        'msg.form.sizeError1':
            'Sila muat naik lampiran yang kurang daripada 5M',
        'msg.form.sizeError2':
            'Sila muat naik lampiran yang kurang daripada 50M',
        'msg.form.submit': 'Penyerahan…',
        'msg.form.upload': 'Pemuatan naik…',
        'msg.email.tip1': 'Mesej anda tidak dapat ditemui',
        'msg.email.tip2':
            'Jika anda pernah meninggalkan mesej sebelumnya, dapat melalui pengesahan peti mel untuk mencari',
        'msg.email.tip3': 'Aktifkan pengesahan peti-mel',
        'msg.email.noData': 'Data tidak wujud di bawah nombor akaun kini',
        'email.verify.tip':
            'Alamat peti-mel yang digunakan semasa memasukkan mesej',
        'email.input.placeholder': 'Masukkan alamat peti-mel',
        'email.submit': 'Hantarkan e-mel',
        'email.rules.error': 'Masukkan peti mel benar',
        'email.code.tip':
            'E-mel dah dihantarkan, masukkan kod pengesahan yang anda menerima',
        'email.code.placeholder': 'Masukkan kod pengesahan',
        'email.code.submit': 'Lihat segera',
        'email.notFind.customer': 'Mesej pelanggan tidak dapat ditemui',
        'email.code.wrong': 'Kesalahan kod pengesahan, masukkan lagi',
        'email.code.expired':
            'Kod pengesahan dah tamat tempoh. Sahkan peti-mel lagi',
        'email.code': 'Kod pengesahan',
        'email.send.frequently':
            'Operasinya terlalu kerap, sila cuba lagi sebentar lagi',
        'comment.fail.400133': 'Tiket ini telah dinilai',
        'not.get.user.info': 'Tidak dapat mendapatkan maklumat anda',
        'user.verify.tip':
            'Anda perlu sahkan sebelum anda boleh melihat kandungan senarai mesej',
        'verify.type.email': 'Pengesahan mel',
        'verify.text': 'sahkan',
        'cancel.text': 'batalkan',
        'get.verify.code': 'Dapatkan kod pengesahan',
        'reGet.verify.code': 'Tangkap semula ',
        'verify.by.email.tip':
            'Kod pengesahan akan dihantar melalui e-mel ke akaun e-mel yang anda masukkan',
        'verify.type.phone': 'Pengesahan SMS',
        'phone.placeholder': 'Sila masukkan nombor telefon anda',
        'verify.by.phone.tip':
            'Kod pengesahan akan dihantar melalui SMS ke nombor telefon yang anda masukkan',
        'phone.error': 'Sila masukkan nombor telefon yang betul',
        'phone.errorCode400150': 'Penghantaran sering kod pengesahan',
        'phone.errorCode400233': 'Templat SMS tidak boleh kosong',
        'phone.errorCode400234': 'Imbangan SMS pemasaran tidak mencukupi',
        'phone.errorCode400235':
            'Pemberitahuan keseimbangan SMS tidak mencukupi',
        'phone.errorCode400247': 'Ralat konfigurasi SMS pemalam urutan kerja',
        'phone.errorCode4400248': 'Gagal mendapatkan templat SMS',
        'phone.errorCode400249':
            'Nombor ini bukan nombor telefon pengguna yang wujud',
        'phone.errorCode400250':
            'Kod pengesahan telah tamat, sila dapatkannya lagi',
        'msg.you.reply': 'Dibalas kepada anda',
        'msg.no.reply':'tiada balasan',
    },
    LOCALE_REQUEST: {
        400016: 'Mendapatkan maklumat pesanan kerja telah tamat tempoh, sila muat semula!'
    },
    LOCALE_SYSTEM: {
        MSG005: ({ name }) =>
            `Conversation with ${name} has been ended temporarily`,
        MSG012: (color) =>
            ` You can <span style="color:${color};text-decoration:underline;" class="js-leave-msg">Leave message</span>`,
        MSG013: 'Send'
    },
    LOCALE_EDITOR: {
        editor: {
            base: {
                remove: 'padam',
                cancel: 'Batal',
                confirm: 'pasti',
                inert: 'masukkan',
                width: 'lebar',
                height: 'tinggi'
            },
            controls: {
                clear: 'kandungan yang jelas',
                undo: 'membatalkan',
                redo: 'buat semula',
                fontSize: 'Saiz huruf',
                lineHeight: 'ketinggian garisan',
                letterSpacing: 'jarak perkataan',
                textIndent: 'inden perenggan',
                increaseIndent: 'meningkatkan lekukan',
                decreaseIndent: 'mengurangkan lekukan',
                border: 'bingkai',
                color: 'warna',
                textColor: 'warna teks',
                backgroundColor: 'warna latar belakang',
                tempColors: 'warna sementara',
                bold: 'berani',
                italic: 'huruf condong',
                underline: 'garis bawah',
                strikeThrough: 'tembus',
                fontFamily: 'fon',
                textAlign: 'penjajaran teks',
                alignLeft: 'dibiarkan',
                alignCenter: 'di tengah',
                alignRight: 'Betul',
                alignJustify: 'kedua-dua hujungnya',
                floatLeft: 'terapung kiri',
                floatRight: 'terapung betul',
                superScript: 'Superskrip',
                subScript: 'subskrip',
                removeStyles: 'gaya yang jelas',
                headings: 'tajuk',
                header: 'tajuk',
                normal: 'konvensional',
                orderedList: 'senarai pesanan',
                unorderedList: 'senarai tidak teratur',
                blockQuote: 'petikan',
                code: 'kod tersebut',
                link: 'Pautan',
                unlink: 'pautan yang jelas',
                hr: 'garisan mendatar',
                media: 'media',
                mediaLibirary: 'Perpustakaan Media',
                emoji: 'Ekspresi kecil',
                fullscreen: 'skrin penuh',
                exitFullscreen: 'Keluar dari Skrin Penuh'
            },
            linkEditor: {
                textInputPlaceHolder: 'masukkan teks pautan',
                linkInputPlaceHolder: '输入Masukkan alamat pautan链接地址',
                inputWithEnterPlaceHolder:
                    'Masukkan alamat pautan dan tekan Enter',
                openInNewWindow: 'buka dalam tetingkap baharu',
                removeLink: 'alih keluar pautan'
            },
            audioPlayer: {
                title: 'mainkan fail audio'
            },
            videoPlayer: {
                title: 'mainkan fail video',
                embedTitle: 'media terbenam'
            },
            media: {
                image: 'gambar',
                video: 'video',
                audio: 'audio',
                embed: 'media terbenam'
            }
        },
        finder: {
            remove: 'padam',
            cancel: 'Batal',
            confirm: 'mengesahkan',
            insert: 'masukkan item yang dipilih',
            width: 'lebar',
            height: 'tinggi',
            image: 'gambar',
            video: 'video',
            audio: 'audio',
            embed: 'media terbenam',
            caption: 'Perpustakaan Media',
            dragTip: 'Klik atau seret fail ke sini',
            dropTip: 'Keluarkan untuk memuat naik',
            selectAll: 'pilih semua',
            deselect: 'membatalkan pemilihan',
            removeSelected: 'memadam item yang dipilih',
            externalInputPlaceHolder: 'Nama sumber|Alamat sumber',
            externalInputTip: `Gunakan "|" untuk memisahkan nama sumber dan alamat sumber`,
            addLocalFile: 'Tambah sumber tempatan',
            addExternalSource: 'Tambah sumber web',
            unnamedItem: 'projek tanpa tajuk',
            confirmInsert: 'Sisipkan item yang dipilih'
        }
    }
}
